import { clientId } from "./constants";
import "./appLinks";

export const productComplianceRoutes = [
  {
    path: "/product-compliance",
    name: "productComplianceDashboard",
    component: () => import("./views/SdsOverviewView.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "sdsNavOverview",
          route: { name: "productComplianceDashboard" },
        },
      ],
    },
  },
  {
    path: "/product-compliance/products",
    name: "productComplianceProducts",
    component: () => import("./views/SdsProductListView.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "sdsNavOverview",
          route: { name: "productComplianceDashboard" },
        },
        {
          label: "sdsNavProducts",
          route: { name: "productComplianceProducts" },
        },
      ],
    },
  },
  {
    path: "/product-compliance/products/:ufi/timeline",
    name: "productComplianceTimeline",
    component: () => import("./views/SdsProductTimelineView.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "productCompliance",
          route: { name: "productComplianceDashboard" },
        },
        {
          label: ":ufi",
          route: { name: "productComplianceWorkspace" },
        },
        {
          label: "productComplianceTimeline",
          route: { name: "productComplianceTimeline" },
        },
      ],
    },
  },
  {
    path: "/product-compliance/actions",
    name: "productComplianceActions",
    component: () => import("./views/SdsActionTrackerView.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "sdsNavOverview",
          route: { name: "productComplianceDashboard" },
        },
        {
          label: "sdsNavActions",
          route: { name: "productComplianceActions" },
        },
      ],
    },
  },
  {
    path: "/product-compliance/products/:ufi",
    name: "productComplianceWorkspace",
    component: () => import("./views/SdsProductWorkspaceView.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "sdsNavOverview",
          route: { name: "productComplianceDashboard" },
        },
        {
          label: "sdsNavProducts",
          route: { name: "productComplianceProducts" },
        },
      ],
    },
  },
  {
    path: "/product-compliance/comparisons/new",
    name: "productComplianceComparisonNew",
    component: () => import("./views/SdsComparisonNewView.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "sdsNavOverview",
          route: { name: "productComplianceDashboard" },
        },
        {
          label: "sdsNavNewComparison",
          route: { name: "productComplianceComparisonNew" },
        },
      ],
    },
  },
  {
    path: "/product-compliance/comparisons/:id",
    name: "productComplianceComparison",
    component: () => import("./views/SdsComparisonView.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "sdsNavOverview",
          route: { name: "productComplianceDashboard" },
        },
        {
          label: "sdsNavProducts",
          route: { name: "productComplianceProducts" },
        },
        {
          label: "sdsNavNewComparison",
          route: { name: "productComplianceComparison" },
        },
      ],
    },
  },
  {
    path: "/product-compliance/suppliers",
    name: "productComplianceSuppliers",
    component: () => import("./views/SdsSupplierListView.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "sdsNavOverview",
          route: { name: "productComplianceDashboard" },
        },
        {
          label: "sdsNavSuppliers",
          route: { name: "productComplianceSuppliers" },
        },
      ],
    },
  },
  {
    path: "/product-compliance/suppliers/:supplierUuid",
    name: "productComplianceSupplierDetail",
    component: () => import("./views/SdsSupplierDetailView.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "sdsNavOverview",
          route: { name: "productComplianceDashboard" },
        },
        {
          label: "sdsNavSuppliers",
          route: { name: "productComplianceSuppliers" },
        },
        {
          label: "sdsSupplierDetailTitle",
          route: { name: "productComplianceSupplierDetail" },
        },
      ],
    },
  },
];
